import { makeStyles } from '@material-ui/core/styles';

export const CORES = {
    verde: '#4B8B33',
    verdeEscuro: '#2F6420',
    verdeClaro: '#EAF3E5',
    texto: '#1B2418',
    textoSuave: '#56604F',
    borda: '#E1E5DE',
    fundoSuave: '#F4F6F3',
    trilho: '#EEF1EC',
};

export const TONS = {
    bom: '#2F6420',
    ruim: '#A63A1A',
    alerta: '#9A6100',
    neutro: '#1B2418',
};

export const SELOS = {
    ok: { background: '#E4EFDF', color: '#1F4615' },
    alerta: { background: '#FFF3DC', color: '#7A4A05' },
    erro: { background: '#FBE6DF', color: '#8E2F12' },
    info: { background: '#E3ECFB', color: '#1E3F8A' },
    neutro: { background: '#EEF1EC', color: '#3D4A38' },
};

const useStyles = makeStyles((theme) => ({
    pagina: {
        maxWidth: 1280,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        color: CORES.texto,
    },
    cabecalho: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16,
        alignItems: 'flex-end',
        justifyContent: 'space-between',
    },
    titulo: { margin: 0, fontSize: 26, fontWeight: 700 },
    subtitulo: { fontSize: 13, color: CORES.textoSuave, marginBottom: 4 },
    acoesCabecalho: { display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' },

    filtros: {
        background: '#fff',
        border: `1px solid ${CORES.borda}`,
        borderRadius: 12,
        padding: '14px 18px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 14,
        alignItems: 'flex-end',
    },
    filtro: { flex: '1 1 200px', minWidth: 0 },
    filtroData: { flex: '0 1 170px' },
    resumoFiltros: { flex: '1 1 100%', fontSize: 13, color: CORES.textoSuave },

    catalogo: {
        background: CORES.verdeClaro,
        border: '1px solid #C5DDBA',
        borderRadius: 12,
        padding: '14px 18px',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    catalogoItens: { display: 'flex', flexWrap: 'wrap', gap: 8 },

    grade: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
        gap: 16,
    },
    s3: { gridColumn: 'span 3' },
    s4: { gridColumn: 'span 4' },
    s6: { gridColumn: 'span 6' },
    s8: { gridColumn: 'span 8' },
    s12: { gridColumn: 'span 12' },
    [theme.breakpoints.down('sm')]: {
        s3: { gridColumn: 'span 6' },
        s4: { gridColumn: 'span 6' },
        s8: { gridColumn: 'span 12' },
    },
    [theme.breakpoints.down('xs')]: {
        compLinha: { gridTemplateColumns: '96px minmax(0,1fr) 64px' },
        barraLinha: { gridTemplateColumns: '110px minmax(0,1fr) 48px' },
        s3: { gridColumn: 'span 12' },
        s4: { gridColumn: 'span 12' },
        s6: { gridColumn: 'span 12' },
        s8: { gridColumn: 'span 12' },
    },

    card: {
        background: '#fff',
        border: `1px solid ${CORES.borda}`,
        borderRadius: 12,
        padding: '16px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        minWidth: 0,
        boxSizing: 'border-box',
    },
    cardEditando: { border: `1.5px dashed ${CORES.verde}`, background: '#FBFDFA' },
    cardTopo: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, minHeight: 32 },
    cardTitulo: {
        margin: 0,
        fontSize: 12,
        fontWeight: 600,
        color: CORES.textoSuave,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
    },
    cardLink: { fontSize: 13, fontWeight: 500, color: CORES.verdeEscuro, textDecoration: 'none', whiteSpace: 'nowrap' },
    ferramentas: { display: 'flex', gap: 4 },
    ferramenta: { minWidth: 32, height: 32, padding: '0 8px' },

    cardDestaque: {
        background: CORES.verdeEscuro,
        border: `1px solid ${CORES.verdeEscuro}`,
        color: '#fff',
        '& h2': { color: '#E4EFDF' },
    },
    seloDestaque: { background: 'rgba(255,255,255,0.18)', color: '#fff', fontWeight: 600, padding: '1px 6px', borderRadius: 5 },

    legenda: {
        display: 'flex',
        gap: 14,
        fontSize: 12,
        color: CORES.textoSuave,
        '& span': { display: 'inline-flex', alignItems: 'center', gap: 6 },
        '& i': { width: 10, height: 10, borderRadius: 2, display: 'inline-block' },
    },
    compLinha: {
        display: 'grid',
        gridTemplateColumns: '150px minmax(0,1fr) 72px',
        gap: 12,
        alignItems: 'center',
        fontSize: 13,
    },
    compValores: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: CORES.textoSuave, whiteSpace: 'nowrap' },

    evolucao: { display: 'flex', alignItems: 'stretch', gap: 2, height: 180, overflowX: 'auto' },
    evoColuna: { flex: '1 0 14px', display: 'flex', flexDirection: 'column', minWidth: 14 },
    evoBarras: {
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
        borderBottom: `1px solid ${CORES.borda}`,
    },
    evoRotulo: { height: 18, fontSize: 10, color: CORES.textoSuave, whiteSpace: 'nowrap', paddingTop: 3 },

    kpiValor: { fontSize: 30, lineHeight: 1.1, fontWeight: 600, fontVariantNumeric: 'tabular-nums' },
    kpiRodape: { fontSize: 13, color: CORES.textoSuave },

    barraLinha: {
        display: 'grid',
        gridTemplateColumns: '150px minmax(0,1fr) 56px',
        gap: 12,
        alignItems: 'center',
        fontSize: 13,
    },
    barraRotulo: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    barraTrilho: { height: 16, background: CORES.trilho, borderRadius: 5, overflow: 'hidden' },
    barraValor: { textAlign: 'right', fontVariantNumeric: 'tabular-nums' },

    linhaLista: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0,1fr) auto',
        gap: 12,
        alignItems: 'center',
        padding: '9px 0',
        borderBottom: `1px solid ${CORES.trilho}`,
        fontSize: 14,
        color: CORES.texto,
        textDecoration: 'none',
    },
    listaLead: { color: CORES.verdeEscuro, fontSize: 13, minWidth: 48, fontVariantNumeric: 'tabular-nums' },
    listaTitulo: { fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    listaSub: { fontSize: 12, color: CORES.textoSuave },
    selo: { fontSize: 12, fontWeight: 600, padding: '3px 8px', borderRadius: 6, whiteSpace: 'nowrap' },

    tabelaWrap: { overflowX: 'auto' },
    tabela: {
        width: '100%',
        minWidth: 560,
        borderCollapse: 'collapse',
        fontSize: 14,
        '& th': { textAlign: 'left', fontWeight: 500, fontSize: 12, color: CORES.textoSuave, padding: '0 8px 8px 0' },
        '& td': { padding: '9px 8px 9px 0', borderTop: `1px solid ${CORES.trilho}` },
    },

    atalhos: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 8 },
    atalho: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        minHeight: 46,
        padding: '0 12px',
        border: `1px solid ${CORES.borda}`,
        borderRadius: 8,
        textDecoration: 'none',
        color: CORES.texto,
        fontSize: 14,
        fontWeight: 500,
        background: '#FAFBF9',
        '&:hover': { background: CORES.verdeClaro },
    },

    vazio: { fontSize: 13, color: CORES.textoSuave, padding: '8px 0' },
    fonte: {
        marginTop: 'auto',
        fontSize: 11,
        fontFamily: 'monospace',
        color: CORES.textoSuave,
        background: CORES.fundoSuave,
        borderRadius: 6,
        padding: '6px 8px',
    },
}));

export default useStyles;
